import { ISubcategoryNavigationData } from './subcategory-navigation.data';
import { ISubcategoryNavigationProps } from './subcategory-navigation.props.autogenerated';

export type ISubcategoryNavigationViewProps = ISubcategoryNavigationProps<ISubcategoryNavigationData>;

const SubcategoryNavigation = (props: ISubcategoryNavigationProps<ISubcategoryNavigationData>) => {
    return props.renderView(props);
};

export default SubcategoryNavigation;
